export const isAuthenticated = (state) => {
  let userDetails = localStorage.getItem("userDetails");
  let sessionToken = localStorage.getItem("sessionToken");
  if (sessionToken && userDetails) {
    return true;
  }
  return false;
};
